import { FC } from "react";
import useNavigateWithToast from "../../../utils/useNavigateWithToast/useNavigateWithToast";
import { useParams } from "react-router-dom";
import { useQueryClient } from "react-query";
import { useGetSize } from "../../../services/size/size.service";
import { useFetchErrorToast } from "../../../utils/useFetchErrorToasts/useFetchErrorToast";
import Header from "../../Bases/Header";
import EditSizeForm from "./EditSizeForm";
import Loading from "../../../components/Loading/Loading";

const EditSize: FC = () => {
  const navigateWithToast = useNavigateWithToast();
  const queryClient = useQueryClient();
  const {
    sizeId: sizeIdParam
  } = useParams<{ sizeId: string }>();
  const sizeId = +(sizeIdParam ?? '-1');

  const {
    data: getSizeResponse,
    isError: getSizeIsError,
    error: getSizeError
  } = useGetSize({ sizeId });
  const size = getSizeResponse?.data;

  useFetchErrorToast([
    {
      label: 'Error fetching size data',
      id: 'sizeDataFetchError',
      isError: getSizeIsError,
      error: getSizeError
    }
  ]);

  const navigateToTableWithSuccessToast = () => {
    queryClient.invalidateQueries(['getSize', sizeId]);
    navigateWithToast(
        `/tables/sizes`,
        {
          label: 'Size has been updated successfully',
          id: 'sizeUpdateSuccess'
        }
    );
  }

  return (
      <>
        <Header
            breadcrumb={{ label: 'Back to Size Table', to: '/tables/sizes' }}
            title={`View Size ${size?.sizeNo ?? ''} - ${size?.longDescription ?? ''}`}
        />
        {!!size
            ? <EditSizeForm
                size={size}
                onSuccess={navigateToTableWithSuccessToast}
            />
            : <Loading size={12}/>
        }
      </>
  );
};

export default EditSize;